module.exports = __webpack_public_path__ + "static/media/0.79cdae53.png";